import Task, { waitAll } from "folktale/concurrency/task";
import { getUserInfo } from "./ognlib";

import { getAndValidateUser, getData } from "./OGN";
import { AUTHLEVEL, prepUI } from "./utils";
import { actions } from "reducer/reducer";

import { loadSounds } from "./sounds";
import { LockScreen } from "../components/Screens";

import { FeedbackModalMessage, LoginModalMessage } from "../components/modals";
import { UI, sounds } from "./app";

const { showAppModal, setModalMessage } = actions.modal;
const { setUI } = actions.UI;
const { loadSoundSources } = actions.sounds;
const { mergePreferences } = actions.preferences;
const { setUsername } = actions.user;

// store => string => Task _ { lockedAuths }
export const showErrorModal = (store = { dispatch: () => {} }, reason) => (
  // Add differentation based on different reasons later
  // eslint-disable-next-line
  store.dispatch(setModalMessage({ component: LoginModalMessage })),
  store.dispatch(showAppModal()),
  Task.of({ lockedAuths: [AUTHLEVEL.paid] })
);

// store => _
export const showFeedbackModal = (store = { dispatch: () => {} }) => (
  // eslint-disable-next-line
  store.dispatch(setModalMessage({ component: FeedbackModalMessage })),
  store.dispatch(showAppModal()),
  Task.of({})
);

// We don't prune paths yet on the base app, only lock them
const prepFn = prepUI(UI, LockScreen, []);
// store => userInfo => Task _ userInfo
export const initializeUI = (
  store = { dispatch: () => {} },
  userInfo = { lockedAuths: [] }
) => (
  // eslint-disable-next-line
  store.dispatch(setUI({ screens: prepFn(userInfo.lockedAuths) })),
  Task.of(userInfo)
);

// store => userData => Task _ userData
export const restoreUserPreferences = (
  store = { dispatch: () => {} },
  preferences = {}
) => (
  // eslint-disable-next-line
  store.dispatch(mergePreferences({ preferences })), Task.of(preferences)
);

// store => sounds => Task _ {key: Howl | Error}
export const initializeSFX = (
  store = { dispatch: () => {} },
  sources = {}
  // eslint-disable-next-line
) => (store.dispatch(loadSoundSources({ sources })), Task.of(sources));

// store => ctx => Task _ {key: Howl | Error}
export const initSounds = (store = {}, soundsToLoad = sounds) => {
  if (`function` !== typeof store.dispatch)
    return Task.rejected(`The app store must have a dispatch method`);

  return loadSounds(soundsToLoad).chain((sounds) =>
    initializeSFX(store, sounds)
  );
};

export const defaultUserName = `No Username Found`;
// store => fn => Task _ userInfo
export const initApp = (store = {}, fn1 = getUserInfo) =>
  `function` === typeof store.dispatch
    ? getAndValidateUser(fn1)
        .chain((userInfo) => {
          store.dispatch(
            setUsername({ username: userInfo?.username ?? defaultUserName })
          );
          return Task.of(userInfo);
        })
        .orElse((reason) => {
          store.dispatch(setUsername({ username: `` }));
          return showErrorModal(store, reason);
        })
    : Task.rejected(`The app store must have a dispatch method`);

// store => AudioContext => fn => Task _ userInfo
export const init = (store = {}, fn1 = getUserInfo) => {
  if (`function` !== typeof store.dispatch)
    return Task.rejected(`The app store must have a dispatch method`);

  return waitAll([initApp(store, fn1), initSounds(store)]).chain((results) => {
    // Using a chain so that the UI is initialized after the stored preferences
    // are retreived from the OGN apps server
    return getData({ field: `preferences` })
      .orElse((_) => Task.of({}))
      .chain(({ data }) => restoreUserPreferences(store, data))
      .chain((_) => initializeUI(store, results[0]));
  });
};
